import { AttributeValue } from '@msdyn365-commerce/retail-proxy';
import * as React from 'react';
import { IProductContainerData } from './product-container.data';
import { IProductContainerProps } from './product-container.props.autogenerated';

/**
 *
 * ProductContainer component
 * @extends {React.Component<IProductContainerProps<IProductContainerData>>}
 */
class ProductContainer extends React.Component<IProductContainerProps<IProductContainerData>> {
    // =========================================================================
    // MODULE-WIDE CONSTANTS
    // =========================================================================
    private productTypeName: string = 'PRODUCT TYPE';

    // =========================================================================
    // PUBLIC METHODS
    // =========================================================================

    // ------------------------------------------------------
    // ------------------------------------------------------
    public render(): JSX.Element | null {
        const { config, slots } = this.props;
        const hasSlots = slots && slots.contentBlock && slots.contentBlock.length;
        const productAttributes = this.props.data.productAttributes.result;
        if (!productAttributes) {
            return null;
        }
        const productAttribute = productAttributes.find(
            attribute =>
                attribute.Name!.toUpperCase() === this.productTypeName
        );

        if (productAttribute && !this._productTypeCheck(productAttribute)) {
            return null;
        } else {
            const productTypeClass = productAttribute && productAttribute.TextValue ? productAttribute.TextValue.replace(/\s+/g, '-').toLowerCase() : '';
            return (
                <div className={`product-container ${productTypeClass} ${config.className || ''}`}>
                    {hasSlots && this._renderSlotItems(slots.contentBlock)}
                </div>
            );
        }
    }

    // =========================================================================
    // PRIVATE METHODS
    // =========================================================================

    // ------------------------------------------------------
    // Returns boolean for showing container based on comparison between product attribute product type and config filter
    // ------------------------------------------------------
    private _productTypeCheck(productAttribute: AttributeValue): boolean {
        const { config } = this.props;
        let showContainer;
        if (config.filterType === 'exclude') {
            showContainer = true;
            config.productTypes?.forEach(productType => {
                if (productType === productAttribute.TextValue) {
                    showContainer = false;
                }
            });
        } else {
            // filter type include
            showContainer = false;
            config.productTypes?.forEach(productType => {
                if (productType === productAttribute.TextValue) {
                    showContainer = true;
                }
            });
        }
        return showContainer;
    }

    // ------------------------------------------------------
    // ------------------------------------------------------
    private _renderSlotItems(items: React.ReactNode[]): JSX.Element {
        return (
            <div className='product-container-slots'>
                {items.map((slot: React.ReactNode, index: number) => (
                    <React.Fragment key={index}>
                        {slot}
                    </React.Fragment>
                ))}
            </div>
        );
    }
}

export default ProductContainer;
